module.exports = __webpack_public_path__ + "img/55.e4564ae5.jpg";